export {
  Colors,
  darkGray,
  blue,
  white,
  bgDark,
  bgLight,
  lightGray,
  lighterBlue,
  lightBlue,
  errorRed,
  placeHolder,
  superLightBlue,
  darkBlue,
  gray,
  green,
  red,
  disabled,
  border,
  title
} from './Colors'


// WEBPACK FOOTER //
// ../../src/Colors/index.js